import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RippleModule } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';

import { SidebarIconComponent } from './sidebar-icon.component';

@Component({
  selector: 'app-sidebar-brand',
  standalone: true,
  imports: [RippleModule, TooltipModule, SidebarIconComponent],
  templateUrl: './sidebar-brand.component.html',
  styleUrls: ['./sidebar-brand.component.scss'],
})
export class SidebarBrandComponent {
  @Input({ required: true }) collapsed = false;

  @Output() toggleRequested = new EventEmitter<void>();
  @Output() homeRequested = new EventEmitter<void>();
}
